import React from 'react';
// src/components/ui/Skeleton.tsx
// Skeleton loading blocks for surfaces with a known layout (STYLEGUIDE §5:
// skeleton bars, not a spinner). Honours prefers-reduced-motion via the global
// reduced-motion rule in index.css.

export const Skeleton: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`animate-pulse bg-ink-100 rounded-sm ${className}`} aria-hidden="true" />
);

interface TableSkeletonProps {
  rows?: number;
  cols?: number;
  className?: string;
}

/** A table-shaped skeleton: a header row plus `rows` body rows of `cols` cells. */
export const TableSkeleton: React.FC<TableSkeletonProps> = ({ rows = 6, cols = 5, className = '' }) => (
  <div className={`w-full ${className}`} role="status" aria-label="Loading">
    <span className="sr-only">Loading…</span>
    <div className="flex flex-col gap-3">
      <div className="flex gap-4 pb-1">
        {Array.from({ length: cols }).map((_, c) => (
          <Skeleton key={c} className={`h-3 ${c === 0 ? 'w-1/4' : 'flex-1'}`} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-4">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton key={c} className={`h-4 ${c === 0 ? 'w-1/4' : 'flex-1'}`} />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Skeleton;
